module.exports = __webpack_public_path__ + "static/media/trash.be841287.svg";